"use client"

import type { HTMLAttributes, ReactNode } from "react"

import { cn } from "@/lib/utils"

type ModalOverlayProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode
}

export function ModalOverlay({
  className,
  children,
  ...props
}: ModalOverlayProps) {
  return (
    <div className={cn("app-modal-overlay", className)} {...props}>
      {children}
    </div>
  )
}

type ModalContentProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode
}

export function ModalContent({
  className,
  children,
  ...props
}: ModalContentProps) {
  return (
    <div className={cn("app-modal-content", className)} {...props}>
      {children}
    </div>
  )
}

type ModalBodyProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode
}

export function ModalBody({ className, children, ...props }: ModalBodyProps) {
  return (
    <div className={cn("app-modal-body", className)} {...props}>
      {children}
    </div>
  )
}
